import script from "./ErrorModalView.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorModalView.vue?vue&type=script&setup=true&lang=js"

import "./ErrorModalView.vue?vue&type=style&index=0&id=fa66e670&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa66e670"]])

export default __exports__